<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari judul atau product ID&hellip;"
                 aria-label="Cari paket langganan" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter platform"
                  (change)="isPlatform = $event.target.value; applyFilter()">
            <option value="">Semua platform</option>
            <option value="android">Play Store</option>
            <option value="ios">App Store</option>
            <option value="web">Web</option>
          </select>
          <select class="vl-select" aria-label="Filter status"
                  (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="1">Aktif</option>
            <option value="0">Nonaktif</option>
          </select>
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Tambah Paket</button>
        </div>
        <div class="vl-hint-bar">
          Paket ini yang ditampilkan aplikasi Hatam di halaman Berlangganan — harga tetap ditentukan lewat Play
          Console / App Store Connect, di sini hanya mengatur katalog: judul, urutan tampil, dan paket mana yang
          ditandai <b>Unggulan</b>.
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Platform</th>
                  <th>Judul</th>
                  <th>Product ID</th>
                  <th>Durasi</th>
                  <th class="text-right">Harga</th>
                  <th class="text-right">Urutan</th>
                  <th>Unggulan</th>
                  <th>Status</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td>
                    <span *ngIf="v.platform == 'android'" class="vl-tag neutral">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path fill="#00C4FF" d="M3.6 1.9c-.36.2-.6.58-.6 1.05v18.1c0 .47.24.85.6 1.05L13.9 12 3.6 1.9z"/>
                        <path fill="#00E36D" d="M17.2 8.7 5.4 2.2l8.5 8.5 3.3-2z"/>
                        <path fill="#F43249" d="M17.2 15.3 13.9 12.8l-8.5 8.5 11.8-6z"/>
                        <path fill="#FFD400" d="M20.7 10.7l-3.5-2-3.3 3.3 3.3 3.3 3.5-2c1-.57 1-2.03 0-2.6z"/>
                      </svg>
                      Play Store</span>
                    <span *ngIf="v.platform == 'ios'" class="vl-tag neutral">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#111" d="M16.36 12.76c-.02-2.22 1.81-3.28 1.89-3.33-1.03-1.5-2.63-1.71-3.2-1.73-1.36-.14-2.66.8-3.35.8-.69 0-1.76-.78-2.89-.76-1.49.02-2.86.86-3.62 2.19-1.55 2.68-.4 6.64 1.11 8.81.74 1.06 1.61 2.26 2.76 2.22 1.11-.05 1.53-.72 2.87-.72 1.34 0 1.72.72 2.89.7 1.2-.02 1.95-1.08 2.68-2.15.85-1.23 1.19-2.42 1.21-2.48-.03-.01-2.32-.89-2.35-3.55zM14.16 5.83c.61-.74 1.02-1.77.91-2.8-.88.04-1.94.59-2.57 1.32-.56.65-1.06 1.7-.93 2.7.98.08 1.98-.5 2.59-1.22z"/></svg>
                      App Store</span>
                    <span *ngIf="v.platform == 'web'" class="vl-tag neutral">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="#3B82F6" stroke-width="1.6" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3.6 9h16.8M3.6 15h16.8M12 3c2.4 2.5 3.6 5.6 3.6 9s-1.2 6.5-3.6 9c-2.4-2.5-3.6-5.6-3.6-9S9.6 5.5 12 3Z"/></svg>
                      Web</span>
                  </td>
                  <td><span class="vl-name" [innerHTML]="highlight(v.title)"></span></td>
                  <td><code class="vl-code" [innerHTML]="highlight(v.product_id)"></code></td>
                  <td>{{v.months}} bulan</td>
                  <td class="text-right">
                    <span *ngIf="v.price != null">{{formatCurrency(v.price)}}</span>
                    <span *ngIf="v.price == null" class="vl-muted">&mdash;</span>
                  </td>
                  <td class="text-right">{{v.sort}}</td>
                  <td>
                    <span *ngIf="v.is_best" class="vl-tag gold">
                      <i class="fa fa-star"></i> Unggulan</span>
                    <span *ngIf="!v.is_best" class="vl-muted">&mdash;</span>
                  </td>
                  <td>
                    <span *ngIf="v.status == 1" class="vl-pill on"><span class="vl-dot"></span>Aktif</span>
                    <span *ngIf="v.status != 1" class="vl-pill off"><span class="vl-dot"></span>Nonaktif</span>
                  </td>
                  <td>
                    <div class="vl-actions">
                      <button type="button" class="vl-icon" title="Edit" (click)="onEdit(v)" data-bs-toggle="modal"
                              data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                      <button type="button" class="vl-icon danger" title="Hapus" (click)="onDelete(v)"><i class="fa fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="9" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> paket</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit Paket' : 'Tambah Paket'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui detail paket langganan ini.' : 'Product ID harus sama persis dengan yang terdaftar di Play Console / App Store Connect.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field">
              <label class="vf-label">Platform <span class="req">*</span></label>
              <select class="vf-input vf-select" [class.invalid]="isInvalid('platform')" formControlName="platform">
                <option value="android">Play Store (Android)</option>
                <option value="ios">App Store (iOS)</option>
                <option value="web">Web</option>
              </select>
              <div class="vf-error" *ngIf="isInvalid('platform')">Platform wajib dipilih.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Product ID <span class="req">*</span></label>
              <input type="text" class="vf-input vf-mono" [class.invalid]="isInvalid('product_id')"
                     placeholder="subscription_yearly" formControlName="product_id">
              <div class="vf-error" *ngIf="isInvalid('product_id')">Product ID wajib diisi.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Judul <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('title')"
                     placeholder="Misal: Tahunan" formControlName="title">
              <div class="vf-error" *ngIf="isInvalid('title')">Judul wajib diisi.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Durasi <span class="req">*</span></label>
              <div class="vf-affix">
                <input type="number" min="1" class="vf-input vf-has-suffix" [class.invalid]="isInvalid('months')"
                       placeholder="12" formControlName="months">
                <span class="suffix">bulan</span>
              </div>
              <div class="vf-error" *ngIf="isInvalid('months')">Durasi wajib diisi, minimal 1 bulan.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Harga</label>
              <div class="vf-affix">
                <span class="prefix">Rp</span>
                <input type="text" inputmode="numeric" class="vf-input vf-has-prefix" [class.invalid]="isInvalid('price')"
                       placeholder="99.000" [value]="formatPriceInput(isForm.get('price').value)"
                       (input)="onPriceInput($event)">
              </div>
              <div class="vf-hint">Hanya dipakai untuk platform Web — harga Play Store/App Store tetap dari console masing-masing.</div>
              <div class="vf-error" *ngIf="isInvalid('price')">Harga tidak boleh negatif.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Urutan Tampil</label>
              <input type="number" min="0" class="vf-input" placeholder="0" formControlName="sort">
              <div class="vf-hint">Angka lebih kecil tampil lebih dulu.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Paket Unggulan</label>
              <select class="vf-input vf-select" formControlName="is_best">
                <option [ngValue]="false">Tidak</option>
                <option [ngValue]="true">Ya — tandai Unggulan</option>
              </select>
            </div>
            <div class="vf-field">
              <label class="vf-label">Status <span class="req">*</span></label>
              <select class="vf-input vf-select" [class.invalid]="isInvalid('status')" formControlName="status">
                <option [ngValue]="1">Aktif — tampil di aplikasi</option>
                <option [ngValue]="0">Nonaktif — disembunyikan</option>
              </select>
              <div class="vf-error" *ngIf="isInvalid('status')">Status wajib dipilih.</div>
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- delete confirmation dialog (custom, design-system styled) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
      </span>
      <h3>Hapus paket ini?</h3>
      <p>Pengguna tidak akan lagi bisa memilih paket ini di halaman Berlangganan.</p>
      <div class="hds-item">
        <span class="hds-item-text">{{isConfirm.v.title}}</span>
      </div>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
        <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
    </div>
  </div>
</div>
